
export class StarterPackageItemVO {
    public id: number = 0;

    public toString(): string {
        return "id: " + this.id;
    }
}
